import { v4 as uuidv4 } from "uuid";
import { getCookie, setCookie } from "cookies-next";

export const getTrackerId = () => {
  const trackerid = getCookie("trackerid");
  if (typeof trackerid === "string") {
    return trackerid;
  } else if (!trackerid) {
    const trackerid = uuidv4();
    setCookie("trackerid", trackerid, {
      maxAge: 365 * 24 * 60 * 60,
      sameSite: "none",
      path: "/",
      secure: true,
    });

    return trackerid;
  }
  return "";
};

export const hasActiveUpi = (user: any): boolean => {
  if (!user.bank_details || !Array.isArray(user.bank_details)) return false;
  return user?.bank_details?.some((detail: any) => detail.type === "upi" && detail.is_active === true);
};

export const filterValidUpiAccounts = (user: any): any[] => {
  if (!user?.bank_details || !Array.isArray(user.bank_details)) return [];
  return user?.bank_details?.filter((detail: any) => detail.type === "upi" && detail.is_active === true);
};
